import React, { useEffect, useState } from 'react'
import './index.scss'
import EarnTime from '@/components/earntime'
import MEarnShow from './mearnshow'
import {driverMoney} from '@/utils/drivermoney'
import {monthIncomeListApi} from '@/api'
const MonthEarn = () => {
  // 月份总额、在线时长、每月收益
  let [amount,setAmount] = useState(0)
  let [onlineTime,setOnlineTime] = useState(0)
  let [monthIncomeList,setMonthIncomeList] = useState([])
  useEffect(() => {
    //请求接口

    driverMoney(monthIncomeListApi,{
    })
    .then( (d) => {
      if(d.data.errorCode === 0){
        if(d.data.data.amount){
          setAmount(d.data.data.amount)
        }
        if(d.data.data.onlineTime){
          setOnlineTime(d.data.data.onlineTime)
        }
        if(d.data.data.monthIncomeList){
          setMonthIncomeList(d.data.data.monthIncomeList)
        }else{
          setMonthIncomeList([])
        }
      }
    } )
    return () => {
    }
  }, [])
  return (
    <div className="month-earn__box">
      {/*  income={} online={} */}
      <EarnTime timeFrame="本月" income={amount} online={onlineTime}></EarnTime>
      <div className="m-earn__show">
        <MEarnShow monthIncomeList={monthIncomeList}/>
      </div>
    </div>
  )
}
export default MonthEarn
